import { render, staticRenderFns } from "./Borrowing.vue?vue&type=template&id=338b51ec&scoped=true"
import script from "./Borrowing.vue?vue&type=script&lang=js"
export * from "./Borrowing.vue?vue&type=script&lang=js"
import style0 from "./Borrowing.vue?vue&type=style&index=0&id=338b51ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338b51ec",
  null
  
)

export default component.exports